import { DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { FileReferenceBase } from './file-reference-base.js';

export class FileReference extends FileReferenceBase {
  static readonly TYPE_ID: string = '87e0d6dec9a84309b1f17a79d4a3851b';

  private constructor(
    public readonly uniqueId: string,
    public readonly storagePath: string,
    public readonly downloadUrl: string,
    public readonly fileName: string | null,
  ) {super();}

  get $typeId() {
    return FileReference.TYPE_ID;
  }

  static create(opts: {
    uniqueId: string,
    storagePath: string,
    downloadUrl: string,
    fileName: string | null,
  }) {
    return new FileReference(
        opts.uniqueId,
        opts.storagePath,
        opts.downloadUrl,
        opts.fileName,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): FileReference {
    return new FileReference(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'storagePath'),
        MapUtils.get<string>(map, 'downloadUrl'),
        MapUtils.getOrNull<string>(map, 'fileName'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'storagePath': this.storagePath,
      'downloadUrl': this.downloadUrl,
      'fileName': this.fileName,
    };
  }

  clone(): this {
    return new FileReference(
        this.uniqueId,
        this.storagePath,
        this.downloadUrl,
        this.fileName,
    ) as this;
  }

  isSame(other: FileReference): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.storagePath === this.storagePath &&
        other.downloadUrl === this.downloadUrl &&
        other.fileName === this.fileName;
  }

  copyWith(data: Partial<FileReference>): this {
    return new FileReference(
        data.uniqueId ?? this.uniqueId,
        data.storagePath ?? this.storagePath,
        data.downloadUrl ?? this.downloadUrl,
        data.fileName ?? this.fileName,
    ) as this;
  }
}

export class FileReferenceBuilder extends DataModelBuilder<FileReference> {
  build(context: SerializationContext, map: SerializedData): FileReference {
    return FileReference.fromMap(context, map);
  }
}
